import { Component, OnInit, Input } from '@angular/core';
import { IStoreMenuCategoryItem } from '../../services/store.service';
import { ModalController } from '@ionic/angular';
import { ShareItemComponent } from '../share-item/share-item.component';
import { FormControl, FormGroup, FormBuilder, Validators, ValidationErrors } from '@angular/forms';
import { ValidatorsService } from '../../../shared/services/validators.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IOrderItem } from '../../services/order.service';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-item-request',
    templateUrl: './item-request.component.html',
    styleUrls: ['./item-request.component.scss'],
    standalone: false
})
export class ItemRequestComponent implements OnInit {
  @Input() item: IStoreMenuCategoryItem;
  @Input() orderItem: IOrderItem;
  @Input() optionIndex;
  title: string = 'SpecialRequest.ItemDetails';

  patternReference: any = {};


  /*-------------------------------------------------------*/
  // new val
  CustomerMessage : FormGroup;
  /*-------------------------------------------------------*/

  numberOfItem: number = 1;

  constructor(private modalCtrl: ModalController,
    private fb: FormBuilder,
    public validators: ValidatorsService,
    public settingService: SettingService,
    public translationService: TranslationService) {
  }

  get total(): number {
    let total = this.orderItem.price * this.orderItem.quantity;   

    for (let i = 0; i < this.orderItem.options.length; i++) {
      let option = this.orderItem.options[i];
      let qty = option.quantity == null ? 1 : option.quantity;      //Just making sure that if the quantity is null, it does not break the calculation
      total += qty * option.price;
    }
  
    return total;
  }

  ngOnInit() {
    this.numberOfItem = this.orderItem.quantity;

    /*-------------------------------------------------------*/
    //newly added

    // new reactive form control/group
    /*
    this.CustomerMessage = this.fb.group({
      allergies: ['', this.validators.formBuilderValidationInitializer(false, 1)],
      ordernote: ['']
    })
    */

    this.CustomerMessage = this.fb.group({
      allergies: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(false, 1)
      }),
      ordernote: this.fb.control('')
    });

    /*
    this.CustomerMessage["patternReference"] = {
      allergies: 1,
      ordernote: null
    };
    */
    this.patternReference = {
      allergies: 1,
      ordernote: null
    };

    // use this for the text area if you'd like to setup some form of validation checkup (do add some error display if we add  this)
    //this.CustomerMessage.get('ordernote')?.markAsTouched();

    //this.validators.trackInputChange(this.CustomerMessage);
    this.validators.trackInputChange(this.CustomerMessage, this.patternReference);
    /*-------------------------------------------------------*/
  }

  cancel() {
    localStorage.removeItem('editKey');
    this.modalCtrl.dismiss({
      cancel: true
    });
  }

  shareItem()
  {
    this.nextOption();
      this.modalCtrl.create({
        component: ShareItemComponent,
        componentProps: {
          item: this.item,
          orderItem: this.orderItem,
          total: this.total
        }
      }).then(m=>{
      m.present();
    })
  }

  changeItemNumber(valuechange) {
    this.numberOfItem = this.numberOfItem + valuechange;
    if(this.numberOfItem < 1) {
      this.numberOfItem = 1;
    } else if (this.numberOfItem > 99) {
      this.numberOfItem = 99;
    }
  }

  nextOption() {

    //sanitizing
    this.CustomerMessage.setValue(this.validators.multiSanitizerInput(this.CustomerMessage.value));

    this.orderItem.quantity = this.numberOfItem;

    // this happens when it's been added to the cart
    // add this to the cart analytics and make the "itemselection" go to false for the editing
    //console.log(this.orderItem);
    //this.analytics.UpdateLocation(null, false, false);

    this.modalCtrl.dismiss({
        cancel: false,
        orderItem: this.orderItem
    });
  }

  goBack()
  {
    this.modalCtrl.dismiss({
      cancel: false,
      item: this.item,
      orderItem: this.orderItem,
      optionIndex: this.optionIndex,
      back: true,
      index: localStorage['editKey'] ? localStorage['editKey'] : null
    });
  }
}